import localforage from "localforage";

localforage.config({
  driver: localforage.LOCALSTORAGE,
  storeName: "mkblite",
});

export default localforage;
